import { SaveButton } from "components/Buttons"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, Row, Label, Input } from "reactstrap"
import { connectUserToPrism } from "store/actions"

const AddSSNForm = ({
  hideSsnModal,
  connectUserToPrism,
  vendorId,
  loading,
  selectedUser,
}) => {
  const [ssn, setSSN] = useState()

  const saveHandler = () => {
    connectUserToPrism({
      last_4_ssn: ssn,
      user_id: selectedUser?.id,
      vendor_id: vendorId,
    })
    hideSsnModal()
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Label for="ssn">
            Last 4 of SSN <span className="text-danger">*</span>
          </Label>
          <Input
            value={ssn}
            onChange={event => setSSN(event?.target?.value)}
            id="ssn"
            className="form-control"
            placeholder="Last 4 of SSN"
          />
        </Col>
      </Row>
      <Row className="justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideSsnModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Save"
            disabled={!ssn}
            onClick={saveHandler}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  loading: state.people.loading,
})

const mapDispatchToProps = dispatch => ({
  connectUserToPrism: values => dispatch(connectUserToPrism(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddSSNForm)
